export const toasterConfig = {
  closeButton: true,
  positionClass: 'toast-top-right-below-header',
  timeOut: 1500,
};
